/**
 * Platform Billing Types
 * ============================================
 * These types are for Workflow 1: Organization Owners paying the PilatesTime Platform
 * This is B2B billing for SaaS subscription management.
 *
 * NOT to be confused with Customer Payments (Workflow 2) where customers pay organizations.
 */
// ============================================
// ENUMS
// ============================================
export var PlatformPlanTier;
(function (PlatformPlanTier) {
    PlatformPlanTier[PlatformPlanTier["FREE"] = 0] = "FREE";
    PlatformPlanTier[PlatformPlanTier["STARTER"] = 1] = "STARTER";
    PlatformPlanTier[PlatformPlanTier["PROFESSIONAL"] = 2] = "PROFESSIONAL";
    PlatformPlanTier[PlatformPlanTier["ENTERPRISE"] = 3] = "ENTERPRISE";
})(PlatformPlanTier || (PlatformPlanTier = {}));
export var PlatformFeatureCode;
(function (PlatformFeatureCode) {
    // Boolean features (enabled/disabled)
    PlatformFeatureCode["MEDICAL_RECORDS"] = "medical_records";
    PlatformFeatureCode["CUSTOMER_IMPORT"] = "customer_import";
    PlatformFeatureCode["ANALYTICS_DASHBOARD"] = "analytics_dashboard";
    PlatformFeatureCode["CUSTOM_BRANDING"] = "custom_branding";
    PlatformFeatureCode["PRIORITY_SUPPORT"] = "priority_support";
    // Quantity-limited features
    PlatformFeatureCode["MAX_ESTABLISHMENTS"] = "max_establishments";
    PlatformFeatureCode["MAX_STAFF_MEMBERS"] = "max_staff_members";
    PlatformFeatureCode["MAX_CUSTOMERS"] = "max_customers";
    PlatformFeatureCode["MAX_SCHEDULES_PER_MONTH"] = "max_schedules_per_month";
    // LLM Features
    PlatformFeatureCode["LLM_ACCESS"] = "llm_access";
    PlatformFeatureCode["LLM_TOKENS_PER_MONTH"] = "llm_tokens_per_month";
})(PlatformFeatureCode || (PlatformFeatureCode = {}));
// Using uppercase values to match Prisma enums
// Maps to Stripe subscription statuses: incomplete, incomplete_expired, trialing, active, past_due, canceled, unpaid, paused
export var PlatformSubscriptionStatus;
(function (PlatformSubscriptionStatus) {
    PlatformSubscriptionStatus["INCOMPLETE"] = "INCOMPLETE";
    PlatformSubscriptionStatus["INCOMPLETE_EXPIRED"] = "INCOMPLETE_EXPIRED";
    PlatformSubscriptionStatus["TRIALING"] = "TRIALING";
    PlatformSubscriptionStatus["ACTIVE"] = "ACTIVE";
    PlatformSubscriptionStatus["PAST_DUE"] = "PAST_DUE";
    PlatformSubscriptionStatus["CANCELED"] = "CANCELED";
    PlatformSubscriptionStatus["UNPAID"] = "UNPAID";
    PlatformSubscriptionStatus["PAUSED"] = "PAUSED";
})(PlatformSubscriptionStatus || (PlatformSubscriptionStatus = {}));
export var PlatformBillingCycle;
(function (PlatformBillingCycle) {
    PlatformBillingCycle["MONTHLY"] = "MONTHLY";
    PlatformBillingCycle["YEARLY"] = "YEARLY";
})(PlatformBillingCycle || (PlatformBillingCycle = {}));
export var PlatformLimitType;
(function (PlatformLimitType) {
    PlatformLimitType["BOOLEAN"] = "BOOLEAN";
    PlatformLimitType["QUANTITY"] = "QUANTITY";
    PlatformLimitType["UNLIMITED"] = "UNLIMITED";
})(PlatformLimitType || (PlatformLimitType = {}));
// Using uppercase values to match Prisma enums
export var PlatformWebhookEventStatus;
(function (PlatformWebhookEventStatus) {
    PlatformWebhookEventStatus["PENDING"] = "PENDING";
    PlatformWebhookEventStatus["PROCESSING"] = "PROCESSING";
    PlatformWebhookEventStatus["PROCESSED"] = "PROCESSED";
    PlatformWebhookEventStatus["FAILED"] = "FAILED";
    PlatformWebhookEventStatus["SKIPPED"] = "SKIPPED";
})(PlatformWebhookEventStatus || (PlatformWebhookEventStatus = {}));
//# sourceMappingURL=PlatformBilling.js.map